import { ProfiloDTO } from "@app/shared/dto/profiloDTO";
import { StrutturaDTO } from "./strutturaDTO";

export class UtenteDTO {
  username: string;
  nome: string;
  cognome: string;
  id: string;
  profili: ProfiloDTO[];
  strutturaAppartenenza: StrutturaDTO;
}
